import { TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { BaseTablePropsType } from "../../../types/container.type";
import { formatDate } from "../../../helpers/dateFormatter";

export const CustomerReportTable: React.FC<BaseTablePropsType> = ({ rows }) => {
	const customerReportTableHeaders = [
		"Customer Name",
		"Account Type",
		"Loan Officer",
		"Activation Date",
		"Status",
	];
	return (
		<BaseTable headers={customerReportTableHeaders}>
			<TableBody>
				{rows?.map((row, index) => (
					<TableRow key={index}>
						<TableCell>
							{`${
								row?.firstName?.charAt(0).toUpperCase() +
								row?.firstName?.slice(1)
							} ${
								row?.lastName?.charAt(0).toUpperCase() + row?.lastName?.slice(1)
							}`}
						</TableCell>
						<TableCell>{row?.accountType}</TableCell>
						<TableCell>{row?.accountManager}</TableCell>
						<TableCell>{formatDate(row?.activationDate, false)}</TableCell>
						<TableCell>
							{row?.status?.charAt(0).toUpperCase() + row?.status?.slice(1) ||
								"NA"}
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</BaseTable>
	);
};
